import React from "react";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import SmartButton from "../../components/SmartButton";
import "./styles.scss";

interface PaymentRestartConfirmPageProps {
    onPaymentRestart: () => Promise<void>;
    isLoading: boolean;
}

const PaymentRestartConfirmPage = (props: PaymentRestartConfirmPageProps) => {
    return (
        <MainLayout>
            <Headline>有料会員プランの継続設定</Headline>
            <section className="payment-restart-confirm">
                <p className="restart-description">
                    現在、有料会員プランは停止予定になっています。
                    <br />
                    継続課金を再開して有料登録状態が継続するように変更します。
                </p>
                <SmartButton
                    isLoading={props.isLoading}
                    onClick={props.onPaymentRestart}
                >
                    有料会員プランを続ける
                </SmartButton>
            </section>
        </MainLayout>
    );
};

export default PaymentRestartConfirmPage;
